import React from 'react';
import { NotificationTemplates as NotificationTemplatesEvidence } from '@eas/common-web';

export function NotificationTemplates() {
  return <NotificationTemplatesEvidence />;
}
